module.exports = __webpack_public_path__ + "static/media/icon_m.e015a2dc.svg";